import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { DashboardService } from '../../../services/dashboard.service';
import { BreakdownAnalysisResponse } from '../../../../maintenance/maintenance-overview/models/maintenance-overview.model';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';
import { BreakdownAnalysisTableComponent } from '../../../../_shared/components/breakdown-analysis-table/breakdown-analysis-table.component';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-total-maintenance-cost-breakdown-modal',
  standalone: true,
  imports: [CommonModule, BreakdownAnalysisTableComponent, TranslocoPipe],
  templateUrl: './total-maintenance-cost-breakdown-modal.component.html',
  styleUrl: './total-maintenance-cost-breakdown-modal.component.scss'
})
export class TotalMaintenanceCostBreakdownModalComponent implements OnInit {
  isLoading: boolean = false;
  data: BreakdownAnalysisResponse[] = [];

  private dashboardService = inject(DashboardService);
  private errorService = inject(ErrorHandlerService);
  private readonly transloco = inject(TranslocoService);
  private cancelSubject = new Subject<void>();

  constructor(private activeModal: NgbActiveModal) { }

  async ngOnInit(): Promise<void> {
    await this.loadData();
  }

  async loadData(): Promise<void> {
    this.isLoading = true;

    try {
      // TODO: Implement actual API call when ready
      // const request = {
      //   accountIds: [],
      //   timeFrom: new Date(),
      //   timeTo: new Date()
      // };
      // const response = await this.dashboardService.getTotalMaintenanceCostBreakdown(request, this.cancelSubject);
      // if (response.data) {
      //   this.data = response.data;
      // }

      // Mock data based on the provided image
      this.data = [
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.totalRepairs'),
          previousValue: '110',
          currentValue: '95',
          change: '-13.64%',
          impactOnEfficiency: 'Increased on Efficiency'
        },
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.costOfParts'),
          previousValue: '1M',
          currentValue: '1M',
          change: '0%',
          impactOnEfficiency: 'Stable'
        },
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.labourCosts'),
          previousValue: '1.2M',
          currentValue: '1.1M',
          change: '-8.33%',
          impactOnEfficiency: 'Increased on Efficiency'
        },
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.inHouseMaintenance'),
          previousValue: '60',
          currentValue: '50',
          change: '-16.67%',
          impactOnEfficiency: 'Increased on Efficiency'
        },
        {
          factor: this.transloco.translate('maintenanceDashboard.breakdownFactors.contract'),
          previousValue: '50',
          currentValue: '45',
          change: '-10%',
          impactOnEfficiency: 'Decreased on Efficiency'
        }
      ];

      this.isLoading = false;
    } catch (error) {
      this.errorService.handleError(error, {
        callback: () => {
          this.isLoading = false;
        }
      });
    }
  }

  closeModal(): void {
    this.cancelSubject.next();
    this.cancelSubject.complete();
    if (this.activeModal) {
      this.activeModal.close();
    }
  }
}